export const CURRENCIES = ["JPY", "IDR"];

export function fmtMoney(v, cur = "JPY") {
  const n = Math.round(Number(v) || 0);
  return cur === "IDR" ? `Rp ${n.toLocaleString("id-ID")}` : `¥${n.toLocaleString("ja-JP")}`;
}

export function fmtDate(s) {
  if (!s) return "-";
  return new Date(`${s}T00:00:00`).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" });
}

export function addMonths(startIso, months) {
  if (!startIso || !months) return null;
  const [y, m, d] = startIso.split("-").map(Number);
  const end = new Date(y, m - 1 + Number(months), 1);
  const last = new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate();
  end.setDate(Math.min(d, last));
  end.setDate(end.getDate() - 1);
  const p = (n) => String(n).padStart(2, "0");
  return `${end.getFullYear()}-${p(end.getMonth() + 1)}-${p(end.getDate())}`;
}

export function calcTotals(f) {
  const subtotal = (Number(f.price_per_account) || 0) * (Number(f.max_uses) || 0) * (Number(f.contract_months) || 0);
  const discount = Math.round((subtotal * (Number(f.discount_pct) || 0)) / 100);
  return { subtotal: Math.round(subtotal), discount, total: Math.round(subtotal) - discount };
}

export const STATUS = {
  active: { label: "Kontrak aktif", cls: "bg-sage-soft text-sage" },
  expiring: { label: "Segera berakhir", cls: "bg-amber-100 text-amber-800" },
  expired: { label: "Kadaluarsa", cls: "bg-primary/10 text-primary" },
  none: { label: "Tanpa kontrak", cls: "bg-muted text-muted-foreground" },
};
